import React, { useContext, useState, useEffect, useMemo, useRef } from "react";
import {
  InputAdornment,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, IconButton, Collapse, Typography, FormControl, InputLabel, Select,
  FormHelperText, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField
} from "@mui/material";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import moment from "moment";
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import { Utils } from "common/Utils";
import TableAllData from "components/Content/CustomTable/TableAllData";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { apiUrls } from "common/ApiUrls";
import { apiGet, apiPost } from "app/Services/ApiService";
import * as Yup from 'yup';
import _ from "lodash";
import { toast } from 'react-toastify';

const formatDate = (date) => date === null ? "N/A" : moment(date).format("MM/DD/YYYY");
const convertToDatePicker = (date) => moment(date).year() > 1900 ? moment(date).format("YYYY-MM-DD") : "";

export default function Details({ viewDataOnly, fetchedData, refreshData }) {
  const { companyId } = useContext(PrivateRoutesContext);
  const [termDate, setTermDate] = useState(fetchedData.termDate)
  const [showTermButton, setShowTermButton] = useState(false)
  const [addEmploymentModal, setAddEmploymentModal] = useState(false)
  const [employmentStatus, setEmploymentStatus] = useState([]);
  const [employeeGroups, setEmployeeGroups] = useState([]);
  const [rehireDate, setRehireDate] = useState(fetchedData.rehireDate)
  const [showRehireButton, setShowRehireButton] = useState(false)

  const initialTableState = {
    pageIndex: 0,
    pageSize: 10,
    sortBy: [
      {
        id: 'beginDate',
        desc: false
      }
    ]
  }
  const [newEmployment, setNewEmployment] = useState({
    EmployeeID: null,
    EmployeeGroupID: null,
    EmploymentStatusID: null,
    JobTitle: null,
    BeginDate: Utils.convertToDatePickerDefaultToday(),
    EndDate: Utils.convertToDatePickerDefaultToday(),
    AnnualSalary: 0,
    WeeklySalary: 0,
    HourlySalary: 0,
    LocationCode: null,
    EmployeeNotes: null,
    EmployeeAltKey: null,
    HireDate: null,
    RehireDate: null,
    InsuredID: null,
    CompanyID: null,
  });

  const [profile, setProfile] = useState({
    InsuredID: null,
    LastName: null,
    Firstname: null,
    //UserName: null,
    SSN: null,
    Email: null,
    BirthDay: null
  });

  const [profileErrors, setProfileErrors] = useState({})
  const [employmentErrors, setEmploymentErrors] = useState({})
  useEffect(() => {
    console.log(fetchedData, 'fetchedData')

    setProfileErrors({})
    setProfile({
      InsuredID: fetchedData.insuredID,
      LastName: fetchedData.lastName,
      FirstName: fetchedData.firstName,
      //UserName: fetchedData.userName,
      SSN: fetchedData.ssn,
      Email: fetchedData.email,
      BirthDay: Utils.convertToDatePicker(fetchedData.dateOfBirth)
    })
  }, [fetchedData])

  const columns = [
    {
      Header: "Begin Date",
      disableFilters: true,
      accessor: (cell) => Utils.formatDate(cell.beginDate),
    },
    {
      Header: "End Date",
      accessor: "endDate",
      disableFilters: true,
      accessor: (cell) => Utils.formatDate(cell.endDate),
    },
    {
      Header: "Employee Group",
      accessor: "employeeGroupCode",
      disableFilters: true,
    },
    {
      Header: "Job Title",
      accessor: "jobTitle",
      disableFilters: true,
    },
    {
      Header: "Status",
      accessor: "employmentStatusName",
      disableFilters: true,
    },
    {
      Header: "Annual Salary",
      accessor: "annualSalary",
      disableFilters: true,
    },
    {
      Header: "Weekly Salary",
      accessor: "weeklySalary",
      disableFilters: true,
    },
    {
      Header: "Hourly Salary",
      accessor: "hourlySalary",
      disableFilters: true,
    },
  ];

  const fetchEmploymentStatus = () => {
    apiGet(apiUrls.getEmploymentStatuses()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchEmploymentStatus");
        setEmploymentStatus(lovResponse.data)
      }
    )
  }

  const fetchEmployeeGroups = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    apiGet(apiUrls.getEmployeeGroups(selectedCompany)).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchEmployeeGroups");
        setEmployeeGroups(lovResponse.data)
      }
    )
  }

  useEffect(() => {
    // fetchStates()
    // fetchMaritalStatuses()
    // fetchGenders()
    fetchEmploymentStatus()
    fetchEmployeeGroups()
  }, []);

  const handleTerminate = () => {
    if (fetchedData.termDate != termDate) {
      console.log(termDate)

      let employees = []
      employees.push(fetchedData.employeeID)
      apiPost(apiUrls.terminateEmployee(companyId, termDate, Utils.convertToDatePickerDefaultToday()), employees)
        .then((res) => {
          refreshData(true)
          toast.success("Employee terminated successfully.");
        })
        .catch(error => {
          const backendMessage = typeof error?.response?.data === "string"
            ? error.response.data
            : error?.response?.data?.message;
          toast.error(backendMessage || "Termination Action Unsuccessful, Please Try Again...");
        });
    }
  }

  const handleRehire = () => {
    let employees = []
    employees.push(fetchedData.employeeID)
    apiPost(apiUrls.rehireEmployee(companyId, rehireDate, Utils.convertToDatePickerDefaultToday()), employees)
      .then((res) => {
        console.log("term employee");
        refreshData(true)
      })
      .catch(error => {
        console.log(
          "Action Unsuccessful, Please Try Again...",
          error
        );
      });
  }

  const handleUpdateProfile = async () => {
    console.log(profile)
    const profileValidationSchema = Yup.object().shape({
      FirstName: Yup.string().required('First Name is required')
        .max(50, 'First Name must not exceed 50 characters'),
      LastName: Yup.string().required('Last Name is required')
        .max(50, 'Last Name must not exceed 50 characters'),
      BirthDay: Yup.date().min('1901-01-01').typeError('Birth date is required'),
      Email: Yup.string().email().required(),
    });
    try {
      const valid = await profileValidationSchema.validateSync(profile,
        { abortEarly: false }
      );
      apiPost(apiUrls.postInsured(profile.InsuredID), profile)
        .then((res) => {
          console.log("update profile");
          refreshData(true)
        })
        .catch(error => {
          console.log(
            "Action Unsuccessful, Please Try Again...",
            error
          );
        });
    } catch (error) {
      let pErrors = {};
      for (const err of error.inner) {
        if (err.path) {
          Object.defineProperty(pErrors, err.path, {
            value: err.message,
            writable: true
          });
          //pErrors[error.path] = error.message;
        }
      }
      setProfileErrors(pErrors)
    }
  }

  const handleChangeTerminateDate = (termDate) => {
    setTermDate(termDate)
    setShowTermButton(true)
  }

  const handleChangeRehireDate = (rehireDate) => {
    setRehireDate(rehireDate)
    setShowRehireButton(true)
  }
  const showAddEmployment = () => {
    setNewEmployment({
      EmployeeID: Utils.emptyGuid(),
      EmployeeGroupID: null,
      EmploymentStatusID: null,
      JobTitle: null,
      BeginDate: Utils.convertToDatePickerDefaultToday(),
      EndDate: Utils.convertToDatePickerDefaultToday(),
      AnnualSalary: 0,
      WeeklySalary: 0,
      HourlySalary: 0,
      LocationCode: fetchedData.locationCode,
      EmployeeNotes: fetchedData.employeeNotes,
      EmployeeAltKey: fetchedData.employeeAltKey,
      HireDate: Utils.convertToDatePickerDefaultToday(fetchedData.dateOfHire),
      RehireDate: fetchedData.rehireDate,
      TermDate: fetchedData.termDate,
      InsuredID: fetchedData.insuredID,
      CompanyID: fetchedData.companyID
    });
    setAddEmploymentModal(true)
    setEmploymentErrors({})
  }

  const handleEmploymentChange = _.debounce((name, val) => {
    let updatedValue = { [name]: val };
    setNewEmployment(newEmployment => ({
      ...newEmployment,
      ...updatedValue
    }));
  }, 500);

  const handleProfileChange = _.debounce((name, val) => {
    let updatedValue = { [name]: val };
    setProfile(newProfile => ({
      ...newProfile,
      ...updatedValue
    }));
  }, 500);

  const saveEmployment = async () => {
    console.log(newEmployment)

    const employmentValidationSchema = Yup.object().shape({
      BeginDate: Yup.date().min('1901-01-01').typeError('Begin date is required'),
      EndDate: Yup.date().min('1901-01-01').typeError('End date is required'),
      EmployeeGroupID: Yup.mixed().required('Employee group is required'),
      EmploymentStatusID: Yup.mixed().required('Employee status is required'),
    });

    try {
      const valid = await employmentValidationSchema.validateSync(newEmployment,
        { abortEarly: false }
      );
      apiPost(apiUrls.postEmployee(), newEmployment)
        .then((res) => {
          console.log("add employee");
          setAddEmploymentModal(false)
          refreshData(true)
        })
        .catch(error => {
          console.log(
            "Action Unsuccessful, Please Try Again...",
            error
          );
        });
    } catch (error) {
      let pErrors = {};
      for (const err of error.inner) {
        if (err.path) {
          Object.defineProperty(pErrors, err.path, {
            value: err.message,
            writable: true
          });
          //pErrors[error.path] = error.message;
        }
      }
      setEmploymentErrors(pErrors)
    }
  }
  return (
    <>
      <div>
        <TextField
          variant="standard"
          className={ModalStyles.cField}
          label="First Name"
          InputLabelProps={{ shrink: true }}
          value={profile.FirstName}
          onChange={e => handleProfileChange('FirstName', e.target.value)}
          error={profileErrors.FirstName ? true : false}
          helperText={profileErrors.FirstName}
        />
        <TextField
          variant="standard"
          className={ModalStyles.cField}
          label="Last Name"
          InputLabelProps={{ shrink: true }}
          value={profile.LastName}
          onChange={e => handleProfileChange('LastName', e.target.value)}
          error={profileErrors.LastName ? true : false}
          helperText={profileErrors.LastName}
        />
        {/* <TextField
        variant="standard"
        className={ModalStyles.cField}
        label="Username"
        InputLabelProps={{ shrink: true }}
        value={profile.UserName}
        onChange={e => handleProfileChange('UserName', e.target.value)}
      /> */}
        <TextField
          variant="standard"
          className={ModalStyles.cField}
          label="SSN"
          InputLabelProps={{ shrink: true }}
          value={profile.SSN}
          onChange={e => handleProfileChange('SSN', e.target.value)}
        />
        <TextField
          variant="standard"
          className={ModalStyles.cField}
          label="Email Address"
          InputLabelProps={{ shrink: true }}
          value={profile.Email}
          onChange={e => handleProfileChange('Email', e.target.value)}
          error={profileErrors.Email ? true : false}
          helperText={profileErrors.Email}
        />

        <TextField
          variant="standard"
          className={ModalStyles.cField}
          label="Date of Birth"
          InputLabelProps={{ shrink: true }}
          type="date"
          value={profile.BirthDay}
          onChange={e => handleProfileChange('BirthDay', e.target.value)}
          error={profileErrors.BirthDay ? true : false}
          helperText={profileErrors.BirthDay}
        />

        <TextField
          variant="standard"
          InputProps={{
            readOnly: true,
          }}
          className={ModalStyles.cField}
          label="Status"
          defaultValue={
            fetchedData.statusCode === null && viewDataOnly ? "N/A" : fetchedData.statusCode
          }
        />
        <TextField
          variant="standard"
          InputProps={{
            readOnly: true,
          }}
          className={ModalStyles.cField}
          label="Contract"
          defaultValue={
            fetchedData.contract === null && viewDataOnly
              ? "N/A"
              : fetchedData.contract
          }
        />
        <TextField
          variant="standard"
          InputProps={{
            readOnly: true,
          }}
          className={ModalStyles.cField}
          label="Classification"
          defaultValue={fetchedData.classification}
        />
        <TextField
          variant="standard"
          InputProps={{
            readOnly: true,
          }}
          className={ModalStyles.cField}
          label="Job Title"
          defaultValue={
            fetchedData.jobTitle === null && viewDataOnly
              ? "N/A"
              : fetchedData.jobTitle
          }
        />
        <TextField
          variant="standard"
          className={ModalStyles.cField}
          label="Date of Hire"
          type="date"
          defaultValue={
            fetchedData.dateOfHire === null && viewDataOnly
              ? "N/A"
              : convertToDatePicker(fetchedData.dateOfHire)
          }
        />
      </div>
      <div>
        <Button
          variant="outlined"
          className={ButtonStyle.CsubmitBtn}
          onClick={handleUpdateProfile}
        >
          Update
        </Button>

      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', height: '100%' }}>
        <TextField
          variant="standard"
          className={ModalStyles.cField}
          label="Date of Termination"
          InputLabelProps={{ shrink: true }}
          type="date"
          onChange={e => handleChangeTerminateDate(e.target.value)}
          defaultValue={
            fetchedData.termDate === null && viewDataOnly
              ? "N/A"
              : convertToDatePicker(fetchedData.termDate)
          }
        />
        {showTermButton ?
          <Button
            variant="outlined"
            onClick={handleTerminate}
            className={ButtonStyle.CsubmitBtn}
            color="error"
          >
            Terminate
          </Button> : <></>}
        {fetchedData?.termDate && moment(fetchedData?.termDate).year() > 1900 ?
          <TextField
            variant="standard"
            className={ModalStyles.cField}
            label="Date of Rehire"
            InputLabelProps={{ shrink: true }}
            type="date"
            onChange={e => handleChangeRehireDate(e.target.value)}
            defaultValue={
              fetchedData.termDate === null && viewDataOnly
                ? "N/A"
                : convertToDatePicker(fetchedData.termDate)
            }
          /> : <></>}
        {showRehireButton ?
          <Button
            variant="outlined"
            onClick={handleRehire}
            className={ButtonStyle.CsubmitBtn}
            color="success"
          >
            Rehire
          </Button> : <></>}
      </div>
      <TableAllData columns={columns} data={fetchedData.employments} initialState={initialTableState}
        headerContents={<>
          <Button
            variant="outlined"
            onClick={showAddEmployment}
            className={ButtonStyle.CsubmitBtn}
          >
            Add Employment
          </Button>
        </>} />


      {/* Add Employment Modal */}
      <Dialog
        open={addEmploymentModal}
        onClose={() => { setAddEmploymentModal(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Add Employment
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>

          <TextField
            variant="standard"
            className={ModalStyles.cField}
            label="Job Title"
            defaultValue={newEmployment.JobTitle}
            onChange={e => handleEmploymentChange('JobTitle', e.target.value)}
          />
          <TextField
            variant="standard"
            className={ModalStyles.cField}
            label="Location Code"
            defaultValue={newEmployment.LocationCode}
            onChange={e => handleEmploymentChange('LocationCode', e.target.value)}
          />
          <TextField
            variant="standard"
            className={ModalStyles.cField}
            label="Begin Date"
            type="date"
            defaultValue={newEmployment.BeginDate}
            onChange={e => handleEmploymentChange('BeginDate', e.target.value)}
            error={profileErrors.BeginDate ? true : false}
            helperText={profileErrors.BeginDate}
          />
          <TextField
            variant="standard"
            className={ModalStyles.cField}
            label="End Date"
            type="date"
            defaultValue={newEmployment.EndDate}
            onChange={e => handleEmploymentChange('EndDate', e.target.value)}
            error={profileErrors.EndDate ? true : false}
            helperText={profileErrors.EndDate}
          />

          <TextField
            variant="standard"
            className={ModalStyles.cField}
            label="Hire Date"
            type="date"
            defaultValue={newEmployment.HireDate}
            onChange={e => handleEmploymentChange('HireDate', e.target.value)}
          />
          <TextField
            variant="standard"
            className={ModalStyles.cField}
            label="Rehire Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            defaultValue={newEmployment.RehireDate}
            onChange={e => handleEmploymentChange('RehireDate', e.target.value)}
          />
          <TextField
            variant="standard"
            className={ModalStyles.cField}
            label="Employee Notes"
            defaultValue={newEmployment.EmployeeNotes}
            onChange={e => handleEmploymentChange('EmployeeNotes', e.target.value)}
          />
          <FormControl sx={{ m: 1, minWidth: 150 }}
            className={ModalStyles.cField}>
            <InputLabel >Employee Group</InputLabel>
            <Select
              id="employeeGroupID"
              name="employeeGroupID"
              label="Employee Group"
              required
              shrink
              size="small"
              variant="standard"
              value={newEmployment.EmployeeGroupID || ''}
              onChange={e => handleEmploymentChange('EmployeeGroupID', e.target.value)}
              error={employmentErrors.EmployeeGroupID ? true : false}
            >
              {employeeGroups.map((val, i) => <MenuItem value={val.employeeGroupId} key={i}>{val.employeeGroupName}</MenuItem>)}
            </Select>
            <FormHelperText id="component-error-text">{employmentErrors.EmployeeGroupID}</FormHelperText>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150 }}
            className={ModalStyles.cField}>
            <InputLabel >Employment Status</InputLabel>
            <Select
              id="employmentStatusID"
              name="employmentStatusID"
              label="Employment Status"
              required
              shrink
              size="small"
              variant="standard"
              value={newEmployment.EmploymentStatusID || ''}
              onChange={e => handleEmploymentChange('EmploymentStatusID', e.target.value)}
              error={employmentErrors.EmploymentStatusID ? true : false}
            >
              {employmentStatus.map((val, i) => <MenuItem value={val.employmentStatusId} key={i}>{val.employmentStatusName}</MenuItem>)}

            </Select>
            <FormHelperText id="component-error-text">{employmentErrors.EmploymentStatusID}</FormHelperText>
          </FormControl>

          <TextField
            variant="standard"
            InputProps={{
              readOnly: viewDataOnly,
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            className={ModalStyles.cField}
            label="Hourly Salary"
            defaultValue={newEmployment.HourlySalary}
            onChange={e => handleEmploymentChange('HourlySalary', e.target.value)}
          />
          <TextField
            variant="standard"
            InputProps={{
              readOnly: viewDataOnly,
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            className={ModalStyles.cField}
            label="Weekly Salary"
            defaultValue={newEmployment.WeeklySalary}
            onChange={e => handleEmploymentChange('WeeklySalary', e.target.value)}
          />
          <TextField
            variant="standard"
            InputProps={{
              readOnly: viewDataOnly,
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            className={ModalStyles.cField}
            label="Annual Salary"
            defaultValue={newEmployment.AnnualSalary}
            onChange={e => handleEmploymentChange('AnnualSalary', e.target.value)}
          />
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={saveEmployment}
            className={ButtonStyle.CcancelBtn}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => { setAddEmploymentModal(false) }}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}